import { render } from "./BandcampPlayer.vue?vue&type=template&id=dce0e3dc"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__